import React from "react";
import { usePurchaseApprovalModel } from "../purchaseApprovalModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import useGlobalModel from "@/model/globalModel";

export function PageHeader() {
    const {
        searchParam,
        initPgCfg,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = usePurchaseApprovalModel();
    const { getSelectedDictOne } = useDictModel();
    const { shopAndOrg: { shopType }, allShopDs } = useGlobalModel();

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "审批单号",
            fieldName: "code",
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "单据状态",
            fieldName: "status",
            options: getSelectedDictOne(DictCodeEnmu.PURCHASE_APPROVAL_STATUS),
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "审批类型",
            fieldName: "approveTypeCode",
            options: getSelectedDictOne(DictCodeEnmu.APPROVAL_TYPE),
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "所属站点",
            fieldName: "shopId",
            options: allShopDs,
            disabled: shopType === 0 ? false : true
        }
        // {
        //     type: SearchTypeEnum.RangePicker,
        //     fieldName: "",
        //     placeholder: ["制单日期起始", "制单日期结束"],
        //     rangePickerFieldName: ["startTime", "endTime"],
        //     format: "YYYY-MM-DD",
        //     span: 6
        // },
        // {
        //     type: SearchTypeEnum.RangePicker,
        //     fieldName: "",
        //     placeholder: ["审批日期起始", "审批日期结束"],
        //     rangePickerFieldName: ["approvalStartTime", "approvalEndTime"],
        //     format: "YYYY-MM-DD",
        //     span: 6
        // },
    ]

    return (
        <>
            <YhPageHeader
                size="small"
                title="采购审批"
                triggerSearch={true}
                searchValues={searchParam as ISearchValue}
                searchFields={searchFields}
                onChange={updateSearchParam}
                handleSearch={(params) => { loadData(initPgCfg, { ...searchParam, ...params }) }}
                handleReset={resetSearchParam}
            />
        </>
    );
}